import NetworkingOperations from "../index";

const PaymentSubmitTourist = (data) => {
	const url = process.env.REACT_APP_PAYMENT_SUBMIT_TOURIST;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaymentSubmitTourist;
